let rootOfMaintenance = null

export function getRootOfMaintenance() {
    return rootOfMaintenance
}

export function setRootOfMaintenance(root) {
    rootOfMaintenance = root
}
